import { Component, OnInit } from '@angular/core';
import { ValidateSubscription } from '../../actions/eliqua.actions';
import { EliquaFacadeService } from '../../services/eliqua.facade.service';

@Component({
  selector: 'dragonfly-locked-overlay',
  templateUrl: './locked-overlay.component.html',
  styleUrls: ['./locked-overlay.component.scss'],
  standalone: false,
})
export class LockedOverlayComponent implements OnInit {
  constructor(public facade: EliquaFacadeService) {}

  ngOnInit(): void {
    this.facade.dispatch(ValidateSubscription());
  }
}
